export default "__VITE_ASSET__BHID75nU__"